import React from 'react';

export default function ObjectivesComingSoon() {
    return (
        <div className="text-sm flex flex-col items-center justify-center p-6 text-center">
            <h3 className="text-xl font-semibold mb-3">Coming Soon!</h3>
            <p className="text-gray-700 mb-4 ">
                Objectives are smart contracts that extend StickerChain.
            </p>
            <p className="text-gray-700 mb-4 ">
                Games, geo-coins, and more!
            </p>
            <p className="text-gray-600">
                Follow <a href='https://twitter.com/ivyroot_zk' target='_blank' className='text-blue-500'>@ivyroot_zk</a> for updates.
            </p>
        </div>
    );
}